import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ContactSectionSchema } from '../types/ContactSectionSchema';

const initialState: ContactSectionSchema = {
    
};

export const ContactSectionSlice = createSlice({
    name: 'ContactSection',
    initialState,
    reducers: {
        template: (state, action: PayloadAction<string>) => {
           
        },
    },
    // extraReducers: (builder) => {
    //     builder
    //         .addCase(, (state) => {
    //             state.error = undefined;
    //             state.isLoading = true;
    //         })
    //         .addCase(, (state) => {
    //             state.isLoading = false;
    //         })
    //         .addCase(, (state, action) => {
    //             state.isLoading = false;
    //             state.error = action.payload;
    //         });
    // },
});

export const { actions: ContactSectionActions } = ContactSectionSlice;
export const { reducer: ContactSectionReducer } = ContactSectionSlice;